import { tgfGraphics } from "../framework/tgfGraphics";
import { getPIXIObjectFromTbObject } from "./tbGetPIXIObject";
import { PIXI } from "./tbPIXI";
export var tbSpriteAnimation = function (frames) {
    "use strict";
    this.x = 0;
    this.y = 0;
    this.scaleX = 1;
    this.scaleY = 1;
    this.frames = frames;
    this.width = 0;
    this.height = 0;
    this.speed = 1;
    this.alpha = 1;
    this._init();
};
tbSpriteAnimation.prototype._init = function () {
    "use strict";
    if (this.frames) {
        this.animation = new PIXI["extras"]["AnimatedSprite"](this.frames);
        this.width = this.animation["width"];
        this.height = this.animation["height"];
    }
};
tbSpriteAnimation.prototype.clone = function () {
    "use strict";
    if (this.frames) {
        var nAnimation = new tbSpriteAnimation(this.frames);
        return nAnimation;
    }
};
tbSpriteAnimation.prototype.play = function () {
    "use strict";
    if (this.animation) {
        this.animation["play"]();
    }
};
tbSpriteAnimation.prototype.stop = function () {
    "use strict";
    if (this.animation) {
        this.animation["stop"]();
    }
};
tbSpriteAnimation.prototype.setPosition = function (x, y) {
    "use strict";
    this.x = x;
    this.y = y;
    if (this.animation) {
        this.animation["x"] = this.x;
        this.animation["y"] = this.y;
    }
};
tbSpriteAnimation.prototype.setScale = function (x, y) {
    "use strict";
    this.scaleX = x;
    this.scaleY = y;
    if (this.animation) {
        this.animation["scale"]["x"] = this.scaleX;
        this.animation["scale"]["y"] = this.scaleY;
    }
};
tbSpriteAnimation.prototype.setAlpha = function (alpha) {
    "use strict";
    this.alpha = alpha;
    if (this.alpha > 1) {
        this.alpha = 1;
    }
    else if (this.alpha < 0) {
        this.alpha = 0;
    }
    this.animation["alpha"] = this.alpha;
};
tbSpriteAnimation.prototype.setSpeed = function (speed) {
    "use strict";
    this.speed = speed ? speed : this.speed;
    if (this.animation) {
        this.animation["animationSpeed"] = this.speed;
    }
};
tbSpriteAnimation.prototype.setLoop = function (loop) {
    "use strict";
    if (this.animation && loop) {
        this.animation["loop"] = loop;
    }
};
tbSpriteAnimation.prototype.setOnComplete = function (callback) {
    "use strict";
    if (this.animation && callback) {
        this.animation["onComplete"] = callback;
    }
};
tbSpriteAnimation.prototype.addChild = function (child) {
    if (!this.animation) {
        return;
    }
    child = getPIXIObjectFromTbObject(child);
    if (child) {
        this.animation["addChild"](child);
    }
};
tbSpriteAnimation.prototype.removeChild = function (child) {
    if (!this.animation) {
        return;
    }
    child = getPIXIObjectFromTbObject(child);
    if (child) {
        this.animation["removeChild"](child);
    }
};
tbSpriteAnimation.prototype.add = function (container) {
    "use strict";
    var obj;
    if (this.animation) {
        obj = this.animation;
    }
    if (obj) {
        if (container && container["addChild"]) {
            container["addChild"](obj);
        }
        else {
            tgfGraphics.addChild(obj);
        }
    }
};
tbSpriteAnimation.prototype.remove = function (container) {
    "use strict";
    var obj;
    if (this.animation) {
        obj = this.animation;
    }
    if (obj) {
        if (container && container["removeChild"]) {
            container["removeChild"](obj);
        }
        else {
            tgfGraphics.removeChild(obj);
        }
    }
};
tbSpriteAnimation.prototype.free = function (alsoChildren) {
    "use strict";
    if (typeof alsoChildren === "undefined") {
        alsoChildren = true;
    }
    var options = { "children": alsoChildren,
        "texture": false,
        "baseTexture": false };
    if (this.animation) {
        this.animation["destroy"](options);
        this.animation = null;
    }
};
tbSpriteAnimation.prototype.setTint = function (tint) {
    "use strict";
    if (this.animation && tint) {
        this.animation["tint"] = tint;
    }
};
tbSpriteAnimation.prototype.setMask = function (mask) {
    "use strict";
    if (this.animation && mask) {
        this.animation["mask"] = mask;
    }
};
